import { RecurringTransferEndType as RecurringTransferEndTypeEnum } from '@fruitful/types';
import { capitalize } from 'lodash';
import { useState } from 'react';
import { RadioInputRow, YStack } from 'smoothie';

interface RecurringTransferEndTypeProps {
    onSubmit: (endType?: RecurringTransferEndTypeEnum) => void;
    endType?: RecurringTransferEndTypeEnum;
}

const RecurringTransferEndType = ({
    onSubmit,
    endType,
}: RecurringTransferEndTypeProps) => {
    const [selectedEndType, setSelectedEndType] =
        useState<RecurringTransferEndTypeEnum | null>(endType ?? null);

    const options = [
        RecurringTransferEndTypeEnum.NEVER,
        RecurringTransferEndTypeEnum.ON,
        RecurringTransferEndTypeEnum.AFTER,
    ];

    const getEndTypeLabel = (type: RecurringTransferEndTypeEnum) => {
        switch (type) {
            case RecurringTransferEndTypeEnum.NEVER:
                return 'Never';
            case RecurringTransferEndTypeEnum.ON:
                return 'On date';
            case RecurringTransferEndTypeEnum.AFTER:
                return 'After number of transfers';
            default:
                return capitalize(type);
        }
    };

    return (
        <YStack width="100%">
            {options.map((end) => (
                <RadioInputRow
                    key={end}
                    label={getEndTypeLabel(end)}
                    isSelected={selectedEndType === end}
                    onPress={() => {
                        setSelectedEndType(end);
                        onSubmit(end);
                    }}
                />
            ))}
        </YStack>
    );
};

export default RecurringTransferEndType;
